import baseAPI from '@/api/base';
import {
  EditShiureiTorah,
  GetShiureiTorah,
  MoveShiureiTorahToFolder,
  MoveShiureiTorahsToFolder,
  RegisterShiureiTorah,
} from '@/dtos/shiurei_torah.dto';
import {
  BULK_DELETE_SHIUREI_TORAHS_URL,
  BULK_MOVE_SHIUREI_TORAHS_TO_FOLDER_URL,
  DELETE_SHIUREI_TORAH_URL,
  EDIT_SHIUREI_TORAH_URL,
  GET_SHIUREI_TORAH_URL,
  MOVE_SHIUREI_TORAH_TO_FOLDER_URL,
  REGISTER_SHIUREI_TORAH_URL,
  TOGGLE_SHIUREI_TORAH_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class ShiureiTorah {
  static getShiureiTorahs = async (
    getShiureiTorah: GetShiureiTorah
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_SHIUREI_TORAH_URL, {
      params: getShiureiTorah,
    });
    console.log('response', response);
    return response;
  };

  static registerShiureiTorah = async (
    registerShiureiTorah: RegisterShiureiTorah
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_SHIUREI_TORAH_URL,
      {
        ...registerShiureiTorah,
      }
    );
    console.log('response', response);
    return response;
  };

  static editShiureiTorah = async (
    editShiureiTorah: EditShiureiTorah
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_SHIUREI_TORAH_URL,
      {
        ...editShiureiTorah,
      }
    );
    return response;
  };

  static toggleShiureiTorahIsActive = async (
    editShiureiTorah: EditShiureiTorah
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_SHIUREI_TORAH_IS_ACTIVE_URL,
      {
        ...editShiureiTorah,
      }
    );
    return response;
  };

  static moveShiureiTorahToFolder = async (
    moveShiureiTorahToFolder: MoveShiureiTorahToFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      MOVE_SHIUREI_TORAH_TO_FOLDER_URL,
      {
        ...moveShiureiTorahToFolder,
      }
    );
    return response;
  };

  static moveShiureiTorahsToFolder = async (
    payload: MoveShiureiTorahsToFolder
  ): Promise<AxiosResponse> => {
    return baseAPI.patch(BULK_MOVE_SHIUREI_TORAHS_TO_FOLDER_URL, payload);
  };

  static deleteShiureiTorah = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_SHIUREI_TORAH_URL}/${id}`
    );
    return response;
  };

  static deleteShiureiTorahs = async (
    ids: string[]
  ): Promise<AxiosResponse> => {
    return baseAPI.delete(BULK_DELETE_SHIUREI_TORAHS_URL, {
      data: { ids },
    });
  };
}

export default ShiureiTorah;
